<!-- components/SvgIcon.vue -->
<template>
  <svg :class="svgClass" aria-hidden="true" :style="{ color: props.color }">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  name: {
    type: String,
    required: true
  },
  prefix: {
    type: String,
    default: 'icon'
  },
  color: {
    type: String,
    default: ''
  }
})

const symbolId = computed(() => `#${props.prefix}-${props.name}`)
const svgClass = computed(() => (props.color ? `svg-icon icon-${props.name} svg-icon-${props.color}` : `svg-icon icon-${props.name}`))
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  fill: currentColor;
  vertical-align: -0.15em;
  overflow: hidden;
}
</style>
